import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { getSelectedResources } from '../utils/exportHelpers'
import paletteOutline from '../../../../assets/images/palette-outline.svg'
import boxArchiveSolid from '../../../../assets/images/box-archive-solid.svg'

const ExcelOptions = ({ onExport, collect, draft }) => {
  const handleCustomize = useCallback(() => {
    const selectedResources = getSelectedResources()
    const params = new URLSearchParams()

    if (selectedResources.resourceIds?.length > 0)
      params.set('resource_ids', selectedResources.resourceIds.join(','))
    if (selectedResources.allResources)
      params.set('all_resources', 'true')
    if (selectedResources.query)
      params.set('q', selectedResources.query)
    if (selectedResources.resourceStatus)
      params.set('resource_status', selectedResources.resourceStatus)
    if (selectedResources.startDate)
      params.set('start_date', selectedResources.startDate)
    if (selectedResources.endDate)
      params.set('end_date', selectedResources.endDate)

    const queryString = params.toString()
    const exportPath = draft?.id ? `/drafts/${draft.id}/resources_exports` : '/resources_exports'
    const baseUrl = `/collects/${collect.id}${exportPath}`
    window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl
  }, [collect.id, draft?.id])

  const handleExportClick = useCallback(() => {
    onExport()
  }, [onExport])

  return (
    <div className="export-type">
      <div className="row">
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleExportClick}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Tout exporter</h4>
                <img src={boxArchiveSolid} style={{ height: '3.5rem' }} alt="Export all" />
              </div>
              <p className="card-text text-center">
                Exportez toutes les données disponibles pour obtenir un aperçu complet de votre collecte.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleCustomize}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Personnaliser l&apos;export</h4>
                <img src={paletteOutline} style={{ height: '3.5rem' }} alt="Customize" />
              </div>
              <p className="card-text text-center">
                Configurez un export ciblé en choisissant les variables et sections qui vous intéressent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ExcelOptions.propTypes = {
  collect: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  draft: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  onExport: PropTypes.func.isRequired
}

ExcelOptions.defaultProps = {
  draft: null
}

export default ExcelOptions
